module.exports = __webpack_public_path__ + "img/multiphones-flat_en.2f2e116.jpg";